<template>
  <div class="avatar" v-bind:style="style">
    <span v-if="!hasImage" class="text-white">{{ initials }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    fullname: { type: String, default: '##' },
    size: { type: Number, default: 40 },
    radius: {
      type: Number,
      default: 50,
      validator: value => value >= 0 && value <= 50
    },
    color: { type: String, default: '' },
    image: { type: String, default: '' }
  },
  computed: {
    initials() {
      const words = this.fullname.split(/[\s-]+/);
      let initials = '';
      for (let i = 0; i < words.length; i++) {
        initials += words[i].substr(0, 1).toUpperCase();
      }
      if (initials.length > 3) {
        initials = initials.substr(0, 3);
      }
      return initials;
    },
    style() {
      const fontSize = this.initials.length > 2 ? this.size / 4 : this.size / 2;
      return {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'flex-shrink': 0,
        width: this.size + 'px',
        height: this.size + 'px',
        'border-radius': this.radius + '%',
        'font-size': fontSize,
        'background-color':
          this.color === '' ? this.toColor(this.fullname) : this.color,
        'background-image': this.hasImage ? 'url(' + this.image + ')' : 'none',
        'background-position': 'center',
        'background-repeat': 'no-repeat',
        'background-size': this.size + 'px ' + this.size + 'px'
      };
    },
    hasImage() {
      return this.image !== '';
    }
  },
  methods: {
    toColor(str) {
      let hash = 0;
      const len = str.length;
      if (len === 0) return 'black';
      for (let i = 0; i < len; i++) {
        hash = (hash << 8) - hash + str.charCodeAt(i);
        hash |= 0;
      }
      hash = Math.abs(hash);
      return '#' + hash.toString(16).substr(0, 6);
    }
  }
};
</script>
